import { Badge } from "@/components/ui/badge";

const STYLES = {
  draft: "border-slate-500/40 bg-slate-500/10 text-slate-500 dark:text-slate-400",
  sent: "border-blue-500/40 bg-blue-500/10 text-blue-600 dark:text-blue-400",
  accepted: "border-emerald-500/40 bg-emerald-500/10 text-emerald-600 dark:text-emerald-400",
  rejected: "border-red-500/40 bg-red-500/10 text-red-600 dark:text-red-400",
  received: "border-amber-500/40 bg-amber-500/10 text-amber-600 dark:text-amber-400",
  in_calibration: "border-blue-500/40 bg-blue-500/10 text-blue-600 dark:text-blue-400",
  completed: "border-emerald-500/40 bg-emerald-500/10 text-emerald-600 dark:text-emerald-400",
  dispatched: "border-slate-500/40 bg-slate-500/10 text-slate-500 dark:text-slate-400",
};

export function StatusBadge({ status, label, testid }) {
  return (
    <Badge
      variant="outline"
      data-testid={testid || `status-badge-${status}`}
      className={`font-mono text-[10px] uppercase tracking-wider ${STYLES[status] || STYLES.draft}`}
    >
      {label || status?.replace(/_/g, " ")}
    </Badge>
  );
}
